var _circle, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg5 = function Svg5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 274 274"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 137,
    cy: 137,
    r: 137,
    fill: "url(#5_svg__a)",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("mask", {
    id: "5_svg__b",
    width: 113,
    height: 113,
    x: 81,
    y: 73,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M81 73h112.667v112.667H81z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#5_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M181.525 160.965h-53.722a4.39 4.39 0 0 1-4.389-4.389v-6.152a4.39 4.39 0 0 1 4.389-4.389h53.722a4.39 4.39 0 0 1 4.389 4.389v6.152a4.39 4.39 0 0 1-4.389 4.389"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB331",
    d: "M187.627 146.035h-53.722a4.39 4.39 0 0 1-4.389-4.389v-6.152a4.39 4.39 0 0 1 4.389-4.389h53.722a4.39 4.39 0 0 1 4.389 4.389v6.152a4.39 4.39 0 0 1-4.389 4.389"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F28230",
    d: "M178.474 131.104h-53.722a4.39 4.39 0 0 1-4.389-4.389v-6.151a4.39 4.39 0 0 1 4.389-4.39h53.722a4.39 4.39 0 0 1 4.39 4.39v6.151a4.39 4.39 0 0 1-4.39 4.389"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB331",
    d: "M181.525 116.174h-53.722a4.39 4.39 0 0 1-4.389-4.389v-6.152a4.39 4.39 0 0 1 4.389-4.389h53.722a4.39 4.39 0 0 1 4.389 4.389v6.152a4.39 4.39 0 0 1-4.389 4.389"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED5C2F",
    d: "M153.754 144.13c0 19.635-15.917 35.552-35.552 35.552S82.65 163.765 82.65 144.13s15.917-35.552 35.552-35.552 35.552 15.917 35.552 35.552"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEF5E5",
    d: "M143.559 144.13c0 14.004-11.353 25.357-25.356 25.357-14.005 0-25.357-11.353-25.357-25.357s11.352-25.356 25.357-25.356c14.003 0 25.356 11.352 25.356 25.356"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAB331",
    d: "m168.582 100.873-1.027 1.996c-1.284 2.492-4.846 2.492-6.13 0l-1.028-1.996a11.4 11.4 0 0 0-4.92-4.92l-1.995-1.027c-2.492-1.284-2.492-4.846 0-6.13l1.995-1.028a11.4 11.4 0 0 0 4.92-4.92l1.028-1.995c1.284-2.491 4.846-2.491 6.13 0l1.027 1.996a11.4 11.4 0 0 0 4.92 4.92l1.995 1.027c2.492 1.284 2.492 4.846 0 6.13l-1.995 1.028a11.4 11.4 0 0 0-4.92 4.919M98.68 102.182l-.826 1.602c-1.031 2.002-3.893 2.002-4.924 0l-.826-1.602a9.17 9.17 0 0 0-3.952-3.952l-1.603-.826c-2.002-1.031-2.002-3.893 0-4.924l1.603-.826a9.17 9.17 0 0 0 3.952-3.952l.826-1.603c1.03-2.001 3.892-2.001 4.924 0l.825 1.603a9.17 9.17 0 0 0 3.952 3.952l1.603.826c2.002 1.031 2.002 3.893 0 4.924l-1.603.826a9.17 9.17 0 0 0-3.952 3.952"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M93.283 169.487c-6.562-6.45-10.633-15.428-10.633-25.357 0-19.634 15.917-35.552 35.552-35.552s35.552 15.918 35.552 35.552c0 19.635-15.917 35.552-35.552 35.552a35.4 35.4 0 0 1-18.679-5.297"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M143.559 144.13c0 14.004-11.353 25.357-25.356 25.357-14.005 0-25.357-11.353-25.357-25.357s11.352-25.356 25.357-25.356c14.003 0 25.356 11.352 25.356 25.356M168.582 100.873l-1.027 1.996c-1.284 2.492-4.846 2.492-6.13 0l-1.028-1.996a11.4 11.4 0 0 0-4.92-4.92l-1.995-1.027c-2.492-1.284-2.492-4.846 0-6.13l1.995-1.028a11.4 11.4 0 0 0 4.92-4.92l1.028-1.995c1.284-2.491 4.846-2.491 6.13 0l1.027 1.996a11.4 11.4 0 0 0 4.92 4.92l1.995 1.027c2.492 1.284 2.492 4.846 0 6.13l-1.995 1.028a11.4 11.4 0 0 0-4.92 4.919M98.68 102.182l-.826 1.602c-1.031 2.002-3.893 2.002-4.924 0l-.826-1.602a9.17 9.17 0 0 0-3.952-3.952l-1.603-.826c-2.002-1.031-2.002-3.893 0-4.924l1.603-.826a9.17 9.17 0 0 0 3.952-3.952l.826-1.603c1.03-2.001 3.892-2.001 4.924 0l.825 1.603a9.17 9.17 0 0 0 3.952 3.952l1.603.826c2.002 1.031 2.002 3.893 0 4.924l-1.603.826a9.17 9.17 0 0 0-3.952 3.952M178.01 101.244h-9.618M140.168 116.174h41.357a4.39 4.39 0 0 0 4.39-4.389v-6.152c0-.886-.264-1.712-.716-2.402"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M160.588 101.244h-32.785a4.39 4.39 0 0 0-4.389 4.389v3.326M178.474 131.104a4.39 4.39 0 0 0 4.389-4.389v-6.151a4.39 4.39 0 0 0-4.389-4.39M153.703 146.035h33.924a4.39 4.39 0 0 0 4.389-4.389v-6.152a4.39 4.39 0 0 0-4.389-4.389h-36.335M149.522 160.965h32.003a4.39 4.39 0 0 0 4.39-4.389v-6.152a4.39 4.39 0 0 0-4.39-4.389M122.838 133.852s-2.638-2.434-6.705-1.209c-3.735 1.126-4.662 6.235-2.125 8.226 1.458 1.143 3.65 2.082 6.605 3.127 6.614 2.338 4.169 11.664-2.558 11.709-2.626.018-3.853-.149-6.159-1.657M118.055 129.15v29.96"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "5_svg__a",
    x1: 137,
    x2: 137,
    y1: 0,
    y2: 274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB331"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB331",
    stopOpacity: 0
  })))));
};
export default Svg5;